import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './AppCard.scss'
import { Link } from 'react-router-dom'

import { InlineShell } from '../Shells'
import { Fade } from '../Transitions'
import { Button } from '../Button'
import AppIcon from './AppIcon'

const htmlDecode = input => {
	var proto = DOMParser.prototype,
		nativeParse = proto.parseFromString

	let doc, result

	try {
		if (new DOMParser().parseFromString('', 'text/html')) {
			doc = new DOMParser().parseFromString(input, 'text/html')
			result = doc.documentElement.textContent
		}
	} catch (ex) {
		proto.parseFromString = function(markup, type) {
			if (/^\s*text\/html\s*(?:;|$)/i.test(type)) {
				doc = document.implementation.createHTMLDocument('')
				if (markup.toLowerCase().indexOf('<!doctype') > -1) {
					doc.documentElement.innerHTML = markup
				} else {
					doc.body.innerHTML = markup
				}
				return doc
			} else {
				result = nativeParse.apply(this, arguments)
			}
		}
	}

	return result
}

const AppCard = ({
	shell,
	id,
	parent,
	category,
	iconUrl,
	title,
	shortDescription,
	status,
	button,
	single,
	dark
}) => {
	if (shell) {
		return (
			<div
				styleName="card-wrapper"
				className={[
					single ? styles.single : '',
					dark ? styles.dark : ''
				].join(' ')}
			>
				<div styleName="card">
					<div styleName="meta-info">
						<AppIcon />
						<div styleName="details">
							<InlineShell width={60} />
						</div>
					</div>
					<div styleName="desc">
						<div styleName="title">
							<InlineShell width={70} />
						</div>
						<div styleName="category">
							<InlineShell width={40} />
						</div>
						<InlineShell width={120} />
					</div>
				</div>
			</div>
		)
	}
	let prettyStatus = ''
	switch (status) {
		case 'IN_DEVELOPMENT':
			prettyStatus = 'Private app'
			break
		case 'IN_REVIEW':
			prettyStatus = 'Pending review'
			break
		case 'ACCEPTED':
			prettyStatus = 'Ready to publish'
			break
		case 'PUBLISHED':
			prettyStatus = 'Public app'
			break
		default:
			prettyStatus = 'Public app'
	}

	if (typeof parent !== 'undefined') {
		prettyStatus += ', clone'
	}

	return (
		<div
			styleName="card-wrapper"
			className={[
				single ? styles.single : '',
				dark ? styles.dark : ''
			].join(' ')}
		>
			<Fade>
				<div styleName="card">
					<div styleName="meta-info">
						<AppIcon url={iconUrl} />
						<div styleName="details">
							{button ? (
								button
							) : (
								<Link to={'/apps/' + id}>
									<Button type={'ghost'} icon={'edit'} />
								</Link>
							)}
						</div>
					</div>
					<div styleName="desc">
						<div styleName="title">{title}</div>
						<div styleName="category">
							{category ? category : prettyStatus}
						</div>
						{htmlDecode(shortDescription) ||
							'Bummer! There is no description for this app.'}
					</div>
				</div>
			</Fade>
		</div>
	)
}

export default CSSModules(AppCard, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/AppCard/AppCard.js